export default "__VITE_ASSET__e3e27615__"